import React, { Component } from 'react';
import { Link } from 'react-router-dom'
class SingleBlogComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: [
                {
                    id: 1,
                    numb: '1',
                    class: 'active'
                },
                {
                    id: 2,
                    numb: '2',
                },
                {
                    id: 3,
                    numb: '>',
                }
            ],
            datablog: [
                {
                    id: '1',
                    srcimg: 'images/blog/blog-content-01.png',
                    title: 'Designing Impactful Surveys',
                    description: 'Best practices for creating survey instruments that yield reliable and valid data.',
                    day: '11',
                    month: 'JAN'
                },
                {
                    id: '2',
                    srcimg: 'images/blog/blog-content-02.png',
                    title: 'Data Quality Assurance',
                    description: 'Strategies to ensure the integrity and accuracy of your research data.',
                    day: '11',
                    month: 'JAN'
                },
                {
                    id: '3',
                    srcimg: 'images/blog/blog-content-03.png',
                    title: 'Qualitative Research Methods',
                    description: 'Deep dive into focus groups, interviews, and other qualitative techniques.',
                    day: '11',
                    month: 'JAN'
                },
            ]
            
        }
    }
render() {
    return (
        <section className="main-content blog-single-post">
			<div className="container">
				<div className="row">
					<div className="post-wrap">
                        {
                            this.state.datablog.map(data=>(
                                <div className="col-md-4" key={data.id} >
                                    <article className="post style2">
                                        <div className="featured-post">
                                            <Link to="/blog" title="" className="post-image">
                                                <img src={data.srcimg && (data.srcimg.startsWith('/') ? data.srcimg : '/' + data.srcimg)} alt="img" />
                                            </Link>
                                            <ul className="post-date">
                                                <li className="day">{data.day}</li>
                                                <li className="month">{data.month}</li>
                                            </ul>
                                        </div>
                                        <div className="content-post">
                                            <h4 className="title-post">
                                                <Link to="/blog" title="">{data.title}</Link>
                                            </h4>
                                            <div className="entry-post">
                                                <p>{data.description}
                                                </p>
                                                <div className="more-link">
                                                    <Link to="/blog" title="">Readmore</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))
                        }
						</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="dividers dividers-pagination"></div>
						<div className="blog-single-pagination">
							<ul className="flat-pagination">
                                {
                                    this.state.pagination.map (data =>(
                                        <li key={data.id} ><Link to="#" className={data.class} title="">{data.numb}</Link></li>
                                    ))
                                }
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
        );
    }
}

export default SingleBlogComponent;
